'use strict';

/**
 * @author Henrik Reinbach Madsen
 * @requires flickity.js https://github.com/metafizzy/flickity
 */

var novicell = novicell || {};


novicell.slideshow = novicell.slideshow || new function () {
    const slideshows = document.querySelectorAll('.js-slideshow');

    this.init = function () {
        if (!slideshows) {
            return;
        }
        for (let i = 0; i < slideshows.length; i++) {
            const slideshowElm = slideshows[i];
            const flkty = new Flickity(slideshowElm, {
                // options
                cellAlign: 'left',
                cellSelector: '.slideshow-slide',
                contain: true,
                wrapAround: true,
                pageDots: true,
                arrowShape: 'M71.3,100 21.3,50 71.3,0 78.7,7.5 36.2,50 78.7,92.5 z',
                prevNextButtons: false
            });
            const nextButton = document.querySelector('.js-slideshow-paging-next');
            nextButton.addEventListener('click', function () {
                flkty.next();
            });

            const previousButton = document.querySelector('.js-slideshow-paging-prev');
            previousButton.addEventListener('click', function () {
                flkty.previous();
            });
        }
        // Video overlay
        /* var videoOverlayTriggers = document.querySelectorAll('.js-video-overlay-trigger');

        for (var i = 0; i < videoOverlayTriggers.length; i++) {
            videoOverlayTriggers[i].addEventListener('click', function (e) {
                e.preventDefault();
                var currentTrigger = this;

                novicell.overlay.create({
                    'videoId': currentTrigger.getAttribute('data-video-id'),
                    'type': currentTrigger.getAttribute('data-type'),
                    'class': 'video-overlay',
                    'autoplay': 1
                });
            });
        } */
    };
}();
